<template>
  <section class="grid-view">
    <multi-card-loader v-if="loader" />
    <b-row v-else>
      <b-col md="12">
        <b-card>
          <b-card-body>
            <b-row>
              <b-col md="10">
                <b-card-text>
                  {{ $t('group is for categorize contact') }}
                </b-card-text>
              </b-col>
              <b-col md="2">
                <b-button
                  variant="success"
                  @click="createButtonClicked"
                >
                  {{ $t('add group') }}
                  <feather-icon icon="PlusIcon" />
                </b-button>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>
    <!-- groups cards sections -->
    <groups-grid
      :items="items"
      :additional-data="additionalData"
      @onItemCreated="getData"
      @onItemUpdated="getData"
      @onDeleteButtonClicked="deleteButtonClicked"
    />
    <!--/ groups cards sections -->
    <list-pagination
      :current="page"
      :current-per-page="perPage"
      :from="from"
      :to="to"
      :total="total"
      :total-page="totalPage"
      @onChangePage="changePage"
    />
  </section>
</template>

<script>
import {
  BCard,
  BCardBody,
  BCardText,
  BButton,
} from 'bootstrap-vue'
import MultiCardLoader from '../../components/loaders/MultiCardLoader'
import GroupsGrid from '../../components/groups/list/GroupsGrid'
import { ListIndex } from '../../common/mixins/list'

export default {
  components: {
    GroupsGrid,
    BCard,
    BCardBody,
    BCardText,
    BButton,
    MultiCardLoader,
  },
  mixins: [ListIndex],
  data() {
    return {
      routeName: 'groups',
    }
  },
  methods: {
    deleteButtonClicked(item) {
      this.showConfirmDialog({ text: 'By deleting the group, the contacts of the group are also deleted' }).then(() => {
        this.deleteItem(item)
      })
    },
  },
}
</script>
